import type { ChangeEvent } from '@brighterly/lib-core-types/ui/inputs/interfaces'
import type { InputMode } from '@brighterly/lib-core-types/ui/inputs/types'

import { getMode } from '@shared/lib/mode'

import { useTutorApplicationStore } from '../store'

interface ReferrerFullNameReturn {
  label: string
  mode: ComputedRef<InputMode>
  setReferrerFullName: (event: ChangeEvent) => void
}

export const useReferrerFullName = (): ReferrerFullNameReturn => {
  const tutorApplicationStore = useTutorApplicationStore()

  const label = 'If so, please enter the referrer’s full name (optional)'

  const mode = computed(() => getMode(tutorApplicationStore.showErrors && !!tutorApplicationStore.form.recommended && !tutorApplicationStore.form.referrerFullName))

  const setReferrerFullName = (event: ChangeEvent): void => {
    tutorApplicationStore.setField('referrerFullName', event.value)
  }

  return {
    label,
    mode,
    setReferrerFullName,
  }
}
